import { useMutation, useQuery } from "@tanstack/react-query";
import { refetchApiInterval } from "../../shared/constants";
import { getAssetsChargingOptions, getFutureChargingOptions, patchChargerLink, updateOrDeactivateChargerLink } from "../api/eflow-charge-operation-planner";
export const useAssetsChargingOptions = (assets, projectId, chargeFilter, fetchChargingData, refetchDataFromApi) => {
    return useQuery({
        enabled: fetchChargingData,
        gcTime: 0,
        queryFn: async () => {
            return await getAssetsChargingOptions(assets, projectId, chargeFilter);
        },
        queryKey: ["assetsChargingOptions", assets, projectId, chargeFilter, refetchDataFromApi],
        refetchInterval: refetchApiInterval,
        retry: 1
    });
};
export const useFutureChargingOptions = (fetchFutureChargeOptions, requestBody, chargeUpto) => {
    return useQuery({
        enabled: fetchFutureChargeOptions,
        gcTime: 0,
        queryFn: async () => {
            return await getFutureChargingOptions(requestBody, chargeUpto);
        },
        queryKey: ["futureChargingOptions", requestBody, chargeUpto],
        refetchInterval: refetchApiInterval,
        retry: 1
    });
};
export const useUpdateOrDeactivateChargerLink = () => {
    return useMutation({
        gcTime: 0,
        mutationFn: (chargerAssetLinkUpdateRequest) => {
            return updateOrDeactivateChargerLink(chargerAssetLinkUpdateRequest);
        },
        retry: false
    });
};
export const usePatchChargerLink = () => {
    return useMutation({
        gcTime: 0,
        mutationFn: (chargerAssetLinkUpdateRequest) => {
            return patchChargerLink(chargerAssetLinkUpdateRequest);
        },
        retry: false
    });
};
